export const translations = {
  en: {
    nav: {
      home: 'Home',
      sales: 'Sales & Investment',
      rental: 'Rental',
      gallery: 'Gallery',
      location: 'Location',
      contact: 'Contact',
    },
    hero: {
      heading1: 'An address that defines',
      heading2: 'your status.',
      subtitle:
        'A unique historic apartment in the heart of Malá Strana. Where history meets the investment of the future.',
      cta1: 'Explore the Investment',
      cta2: 'Book a Stay',
      scroll: 'Scroll',
    },
    essence: {
      label: 'About the Apartment',
      heading1: 'A living gallery of',
      heading2: 'European history.',
      p1: 'Malá Strana is not just a neighborhood. It is a living gallery of European history. We offer you a space that carries the genius loci of old Prague, sensitively reconstructed for the needs of the most discerning modern clientele.',
      p2: 'Whether you are looking for a safe haven for your capital, or an unforgettable retreat for your visit to Prague, you are in the right place.',
    },
    gallery: {
      title: 'Gallery',
      close: 'Close gallery',
      prev: 'Previous image',
      next: 'Next image',
    },
    sales: {
      heading: 'Acquisition of Historical Heritage',
      subtitle:
        'Investing in property in Malá Strana is a decision that transcends market fluctuations.',
      features: [
        {
          title: 'Rarity',
          desc: 'The number of historic properties in this location is finite. Owning an apartment at this address means owning a piece of history whose value only grows with time.',
        },
        {
          title: 'Location',
          desc: 'In close proximity to embassies, Prague Castle, and Charles Bridge. In a zone with the highest level of heritage protection and maximum security.',
        },
        {
          title: 'Investment Potential',
          desc: 'Stable rental income combined with capital appreciation in the most sought-after location in Central Europe.',
        },
      ],
      techLabel: 'Technical Parameters',
      area: 'Area',
      layout: 'Layout',
      floor: 'Floor',
      condition: 'Condition',
      areaVal: '116 m²',
      layoutVal: '3+1',
      floorVal: '2nd Floor',
      conditionVal: 'Renovated',
      floorPlan: 'Floor Plan',
      cta: 'Request More Information',
    },
    stay: {
      heading1: 'Live like Prague',
      heading2: 'nobility',
      subtitle: "An authentic experience you won't find in a five-star hotel.",
      features: [
        {
          title: 'Your Private Home',
          desc: 'Enjoy generous spaces with period features, high ceilings, and views of picturesque lanes.',
        },
        {
          title: 'Modern Comfort',
          desc: 'Despite its historic character, the apartment is equipped with top technology, high-speed internet, and a luxury bathroom.',
        },
        {
          title: 'Experiences Within Reach',
          desc: "The best Prague restaurants, hidden gardens, and historic monuments are just a few minutes' walk away.",
        },
      ],
      amenitiesLabel: 'Amenities',
      amenities: [
        'A kingdom of tranquility in the center of it all.',
        'Designer furniture and premium materials.',
        'Fully equipped kitchen for your maximum comfort.',
        'Personalized check-in and concierge services.',
      ],
      cta: 'Check Availability & Price',
    },
    location: {
      heading1: 'Malá Strana:',
      heading2: 'Heart of Old Europe',
      desc: 'Walk in the footsteps of kings. Malá Strana is the best-preserved historic district of Prague, characterized by its baroque palaces, winding lanes, and mysterious gardens.',
      cards: [
        {
          title: 'Culture',
          desc: 'Near the Church of St. Nicholas and countless galleries.',
        },
        {
          title: 'Gastronomy',
          desc: 'From traditional Czech taverns to Michelin-starred restaurants.',
        },
        {
          title: 'Atmosphere',
          desc: 'Morning coffee at Malostranské Square is a ritual you will fall in love with.',
        },
      ],
    },
    contact: {
      heading1: 'We are at',
      heading2: 'your service',
      desc: 'Have questions about the sale, or would you like to book a date for your next stay? Our team speaks fluent English and is ready to ensure everything for your satisfaction.',
      addressLabel: 'Address',
      phoneLabel: 'Phone',
      emailLabel: 'Email',
      formLabels: {
        name: 'Name',
        email: 'Email',
        interest: 'Subject of Interest',
        message: 'Message',
      },
      formPlaceholders: {
        name: 'Your name',
        email: 'your@email.com',
        message: 'How can we help you?',
      },
      selectOptions: {
        sale: 'Sale / Investment',
        rental: 'Rental / Accommodation',
        other: 'Other',
      },
      submitBtn: 'Send Message',
      alertMsg: 'Thank you for your interest. We will contact you soon.',
      defaultInterest: 'Sale',
    },
    footer: {
      rights: 'All rights reserved.',
    },
  },
  de: {
    nav: {
      home: 'Home',
      sales: 'Verkauf & Investition',
      rental: 'Vermietung',
      gallery: 'Galerie',
      location: 'Lage',
      contact: 'Kontakt',
    },
    hero: {
      heading1: 'Eine Adresse, die',
      heading2: 'Ihren Status definiert.',
      subtitle:
        'Ein einzigartiges historisches Apartment im Herzen der Malá Strana. Wo Geschichte auf die Investition der Zukunft trifft.',
      cta1: 'Investition erkunden',
      cta2: 'Aufenthalt buchen',
      scroll: 'Scrollen',
    },
    essence: {
      label: 'Über das Apartment',
      heading1: 'Eine lebendige Galerie',
      heading2: 'europäischer Geschichte.',
      p1: 'Malá Strana ist nicht nur ein Viertel. Es ist eine lebendige Galerie europäischer Geschichte. Wir bieten Ihnen einen Raum, der den Genius Loci des alten Prag in sich trägt, einfühlsam rekonstruiert für die Bedürfnisse der anspruchsvollsten modernen Klientel.',
      p2: 'Ob Sie einen sicheren Hafen für Ihr Kapital suchen oder einen unvergesslichen Rückzugsort für Ihren Besuch in Prag – Sie sind am richtigen Ort.',
    },
    gallery: {
      title: 'Galerie',
      close: 'Galerie schließen',
      prev: 'Vorheriges Bild',
      next: 'Nächstes Bild',
    },
    sales: {
      heading: 'Erwerb eines historischen Erbes',
      subtitle:
        'Eine Investition in eine Immobilie in der Malá Strana ist eine Entscheidung, die Marktschwankungen übersteigt.',
      features: [
        {
          title: 'Seltenheit',
          desc: 'Die Anzahl historischer Objekte an diesem Standort ist begrenzt. Eine Wohnung an dieser Adresse zu besitzen bedeutet, ein Stück Geschichte zu besitzen, dessen Wert mit der Zeit nur wächst.',
        },
        {
          title: 'Lage',
          desc: 'In unmittelbarer Nähe von Botschaften, der Prager Burg und der Karlsbrücke. In einer Zone mit dem höchsten Denkmalschutz und maximaler Sicherheit.',
        },
        {
          title: 'Investitionspotenzial',
          desc: 'Stabile Mieteinnahmen kombiniert mit Kapitalwertsteigerung in der begehrtesten Lage Mitteleuropas.',
        },
      ],
      techLabel: 'Technische Parameter',
      area: 'Fläche',
      layout: 'Grundriss',
      floor: 'Etage',
      condition: 'Zustand',
      areaVal: '116 m²',
      layoutVal: '3+1',
      floorVal: '2. OG',
      conditionVal: 'Renoviert',
      floorPlan: 'Grundriss',
      cta: 'Weitere Informationen anfordern',
    },
    stay: {
      heading1: 'Leben Sie wie Prager',
      heading2: 'Adel',
      subtitle:
        'Ein authentisches Erlebnis, das Sie in keinem Fünf-Sterne-Hotel finden.',
      features: [
        {
          title: 'Ihr privates Zuhause',
          desc: 'Genießen Sie großzügige Räume mit historischen Elementen, hohen Decken und Blick in malerische Gassen.',
        },
        {
          title: 'Moderner Komfort',
          desc: 'Trotz seines historischen Charakters ist das Apartment mit modernster Technik, Highspeed-Internet und einem luxuriösen Badezimmer ausgestattet.',
        },
        {
          title: 'Erlebnisse in Reichweite',
          desc: 'Die besten Prager Restaurants, versteckte Gärten und historische Denkmäler sind nur wenige Gehminuten entfernt.',
        },
      ],
      amenitiesLabel: 'Ausstattung',
      amenities: [
        'Ein Königreich der Ruhe im Zentrum des Geschehens.',
        'Designermöbel und Premium-Materialien.',
        'Voll ausgestattete Küche für Ihren maximalen Komfort.',
        'Personalisierter Check-in und Concierge-Service.',
      ],
      cta: 'Verfügbarkeit & Preis prüfen',
    },
    location: {
      heading1: 'Malá Strana:',
      heading2: 'Herz des alten Europa',
      desc: 'Wandeln Sie auf den Spuren der Könige. Malá Strana ist das besterhaltene historische Viertel Prags, geprägt von barocken Palästen, gewundenen Gassen und geheimnisvollen Gärten.',
      cards: [
        {
          title: 'Kultur',
          desc: 'In der Nähe der St.-Nikolaus-Kirche und zahlreicher Galerien.',
        },
        {
          title: 'Gastronomie',
          desc: 'Von traditionellen tschechischen Gasthäusern bis zu Michelin-Restaurants.',
        },
        {
          title: 'Atmosphäre',
          desc: 'Der Morgenkaffee am Malostranské-Platz ist ein Ritual, das Sie lieben werden.',
        },
      ],
    },
    contact: {
      heading1: 'Wir stehen Ihnen',
      heading2: 'zur Verfügung',
      desc: 'Haben Sie Fragen zum Verkauf oder möchten Sie einen Termin für Ihren nächsten Aufenthalt buchen? Unser Team spricht fließend Englisch und ist bereit, alles für Ihre Zufriedenheit zu gewährleisten.',
      addressLabel: 'Adresse',
      phoneLabel: 'Telefon',
      emailLabel: 'E-Mail',
      formLabels: {
        name: 'Name',
        email: 'E-Mail',
        interest: 'Interessengebiet',
        message: 'Nachricht',
      },
      formPlaceholders: {
        name: 'Ihr Name',
        email: 'ihre@email.com',
        message: 'Wie können wir Ihnen helfen?',
      },
      selectOptions: {
        sale: 'Verkauf / Investition',
        rental: 'Vermietung / Unterkunft',
        other: 'Sonstiges',
      },
      submitBtn: 'Nachricht senden',
      alertMsg:
        'Vielen Dank für Ihr Interesse. Wir werden Sie in Kürze kontaktieren.',
      defaultInterest: 'Verkauf',
    },
    footer: {
      rights: 'Alle Rechte vorbehalten.',
    },
  },
  fr: {
    nav: {
      home: 'Accueil',
      sales: 'Vente & Investissement',
      rental: 'Location',
      gallery: 'Galerie',
      location: 'Emplacement',
      contact: 'Contact',
    },
    hero: {
      heading1: 'Une adresse qui définit',
      heading2: 'votre statut.',
      subtitle:
        "Un appartement historique unique au cœur de Malá Strana. Là où l'histoire rencontre l'investissement de demain.",
      cta1: "Explorer l'investissement",
      cta2: 'Réserver un séjour',
      scroll: 'Défiler',
    },
    essence: {
      label: "À propos de l'appartement",
      heading1: 'Une galerie vivante de',
      heading2: "l'histoire européenne.",
      p1: "Malá Strana n'est pas qu'un quartier. C'est une galerie vivante de l'histoire européenne. Nous vous offrons un espace qui porte le genius loci de la vieille Prague, délicatement reconstruit pour les besoins de la clientèle moderne la plus exigeante.",
      p2: 'Que vous cherchiez un refuge sûr pour votre capital ou une retraite inoubliable pour votre visite à Prague, vous êtes au bon endroit.',
    },
    gallery: {
      title: 'Galerie',
      close: 'Fermer la galerie',
      prev: 'Image précédente',
      next: 'Image suivante',
    },
    sales: {
      heading: "Acquisition d'un patrimoine historique",
      subtitle:
        'Investir dans un bien immobilier à Malá Strana est une décision qui transcende les fluctuations du marché.',
      features: [
        {
          title: 'Rareté',
          desc: "Le nombre de propriétés historiques dans cette localité est limité. Posséder un appartement à cette adresse signifie posséder un morceau d'histoire dont la valeur ne fait que croître avec le temps.",
        },
        {
          title: 'Emplacement',
          desc: 'À proximité immédiate des ambassades, du Château de Prague et du Pont Charles. Dans une zone bénéficiant du plus haut niveau de protection patrimoniale et de sécurité maximale.',
        },
        {
          title: "Potentiel d'investissement",
          desc: "Des revenus locatifs stables combinés à une appréciation du capital dans l'emplacement le plus recherché d'Europe centrale.",
        },
      ],
      techLabel: 'Paramètres techniques',
      area: 'Surface',
      layout: 'Disposition',
      floor: 'Étage',
      condition: 'État',
      areaVal: '116 m²',
      layoutVal: '3+1',
      floorVal: '2e étage',
      conditionVal: 'Rénové',
      floorPlan: "Plan d'étage",
      cta: "Demander plus d'informations",
    },
    stay: {
      heading1: 'Vivez comme la noblesse',
      heading2: 'pragoise',
      subtitle:
        'Une expérience authentique que vous ne trouverez dans aucun hôtel cinq étoiles.',
      features: [
        {
          title: 'Votre résidence privée',
          desc: "Profitez d'espaces généreux avec des éléments d'époque, de hauts plafonds et des vues sur des ruelles pittoresques.",
        },
        {
          title: 'Confort moderne',
          desc: "Malgré son caractère historique, l'appartement est équipé de technologies de pointe, d'internet haut débit et d'une salle de bain luxueuse.",
        },
        {
          title: 'Expériences à portée de main',
          desc: "Les meilleurs restaurants de Prague, les jardins cachés et les monuments historiques ne sont qu'à quelques minutes à pied.",
        },
      ],
      amenitiesLabel: 'Équipements',
      amenities: [
        "Un royaume de tranquillité au cœur de l'action.",
        'Mobilier design et matériaux haut de gamme.',
        'Cuisine entièrement équipée pour votre confort maximal.',
        'Enregistrement personnalisé et services de conciergerie.',
      ],
      cta: 'Vérifier la disponibilité et le prix',
    },
    location: {
      heading1: 'Malá Strana :',
      heading2: 'Cœur de la vieille Europe',
      desc: 'Marchez là où marchaient les rois. Malá Strana est le quartier historique le mieux préservé de Prague, caractérisé par ses palais baroques, ses ruelles sinueuses et ses jardins mystérieux.',
      cards: [
        {
          title: 'Culture',
          desc: "À proximité de l'église Saint-Nicolas et d'innombrables galeries.",
        },
        {
          title: 'Gastronomie',
          desc: 'Des tavernes tchèques traditionnelles aux restaurants étoilés Michelin.',
        },
        {
          title: 'Atmosphère',
          desc: 'Le café du matin sur la place Malostranské est un rituel dont vous tomberez amoureux.',
        },
      ],
    },
    contact: {
      heading1: 'Nous sommes à',
      heading2: 'votre disposition',
      desc: 'Vous avez des questions sur la vente ou souhaitez réserver une date pour votre prochain séjour ? Notre équipe parle couramment anglais et est prête à tout organiser pour votre satisfaction.',
      addressLabel: 'Adresse',
      phoneLabel: 'Téléphone',
      emailLabel: 'E-mail',
      formLabels: {
        name: 'Nom',
        email: 'E-mail',
        interest: "Objet d'intérêt",
        message: 'Message',
      },
      formPlaceholders: {
        name: 'Votre nom',
        email: 'votre@email.com',
        message: 'Comment pouvons-nous vous aider ?',
      },
      selectOptions: {
        sale: 'Vente / Investissement',
        rental: 'Location / Hébergement',
        other: 'Autre',
      },
      submitBtn: 'Envoyer le message',
      alertMsg: 'Merci pour votre intérêt. Nous vous contacterons bientôt.',
      defaultInterest: 'Vente',
    },
    footer: {
      rights: 'Tous droits réservés.',
    },
  },
}
